export default __webpack_public_path__ + "static/media/girldev.31ceea80.png";